import Vue from 'vue';
import VueAxios from 'vue-axios';
import axios from 'axios';
import Qs from 'qs';
import { requestToken, convertDates, datesToString } from '@/helpers/Utils';

Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL;
Vue.axios.interceptors.request.use(config =>
{
    let url = new URL(`${config.baseURL}/${config.url}`);
    config.headers.common['Accept-Language'] = Vue.i18n.locale() || '';
    config.headers.common['Request-Token'] = requestToken(url.pathname, Vue.auth.token());
    config.headers.common['Impersonate'] = Vue.auth.impersonating() || '';

    if (Vue.auth.token())
    {
        config.headers.Authorization = `Bearer ${Vue.auth.token()}`;
    }

    config.paramsSerializer = params =>
    {
        return Qs.stringify(datesToString(params), {
            arrayFormat: "brackets",
            encode: false
        });
    };

    return config;
});
Vue.axios.interceptors.response.use(
    response =>
    {
        return convertDates(response);
    },
    error =>
    {
        let ex = {
            code: 500,
            message: 'Unexpected exception occured.',
            data: null as any,
            inner: null as any
        };

        if (error.response)
        {
            ex.code = error.response.status;
            ex.data = (typeof error.response.data === 'string') ? { message: error.response.data } : error.response.data;
            ex.message = ex.data.message ? ex.data.message : error.message;
            ex.inner = error;
        }

        if (ex.code === 401)
        {
            Vue.auth.logout();
        }
        if (ex.code === 403)
        {
            if (error.response.config.method === "get")
                Vue.router.replace({ name: 'error-403' });
            else
                Vue.alert.danger(Vue.i18n.translate('[[[Nie masz wymaganych uprawnień do wykonania wybranej operacji.]]]'));
        }
        if (ex.code === 404)
        {
            Vue.alert.danger(Vue.i18n.translate('[[[Błąd 404. Nie znaleziono żądanego zasobu.]]]'));
        }
        if (ex.code === 500)
        {
            if (error.message && error.message == "Network Error")
            {
                Vue.alert.danger(Vue.i18n.translate('[[[Wystąpił błąd połączenia. Upewnij się że masz włączony internet i spróbuj ponownie.]]]'));
            }
            else
            {
                Vue.alert.danger(Vue.i18n.translate('[[[Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.]]]'));
            }

            if (ex.data && ex.data.stackTrace)
            {
                console.log(ex.data.message);
                console.log(ex.data.stackTrace);
            }
        }

        return Promise.reject(ex);
    }
);
